<template>
  <slot v-if="isShow"></slot>
</template>

<script>

import {role, validateRole} from '@/helpers/role'

export default {
  props: {
    roles: [Array, String]
  },
  computed: {
    isShow() {
      const currentUser = this.$store.getters.currentUser;
     
      return (!Array.isArray(this.roles) ? [this.roles] : this.roles).map(r => r.toLowerCase()).includes(currentUser.role.toLowerCase())
      // return validateRole(this.roles)
    }
  }
}
</script>